<template>
  <proa-card
    :class="[
      'meeting-room-card d-flex flex-column text-secondary',
      { 'clickable': meetingRoom.scheduled() }
    ]"
    @click.native="onClickMeetingRoom"
  >
    <div class="d-flex justify-content-between px-3 pt-3">
      <div class="room-name">
        <img :src="require('@/assets/images/icons/meeting_room.png')" />
        <span>{{ meetingRoom.roomName }}</span>
      </div>
      <div class="room-end-at" v-if="meetingRoom.inDuration()">
        〜{{ new Date(meetingRoom.meta.latestRoomInfo.endAt) | moment('HH:mm') }}
      </div>
    </div>
    <div class="d-flex flex-row align-items-center justify-content-center flex-grow-1">
      <div v-if="meetingRoom.inDuration()" class="in-duration">
        <div v-for="user in latestRoomInfoUsers.visibleUsers" :key="user.id" class="avatar-wrapper">
          <proa-avatar v-if="user.temporaryGuest" :src="require('@/assets/images/avatar_default.png')" size="sm" guest/>
          <proa-avatar v-else :src="user.meta.avatar || require('@/assets/images/avatar_default.png')" size="sm"/>
        </div>
        <div
          v-if="latestRoomInfoUsers.omitted"
          class="omitted"
        >
          <span>{{ $t('common.threePointReader') }}</span>
          <span class="font-weight-w6">{{ latestRoomInfoUsers.count + $t('common.person') }}</span>
        </div>
      </div>
      <div v-else class="pb-3 scheduled">
        <span v-if="meetingRoom.scheduled()">{{ new Date(meetingRoom.meta.latestRoomInfo.startAt) | moment('HH:mm') }}〜利用予定</span>
        <span v-else>本日利用予定なし</span>
      </div>
    </div>
  </proa-card>
</template>

<script>
export default {
  name: 'MeetingRoomCard',
  props: {
    meetingRoom: Object
  },
  computed: {
    latestRoomInfoUsers: function() {
      const users = this.meetingRoom.getLatestRoomInfoUsers()
      const visibleUsers = users.filter((_, i) => i < 9)
      return {
        visibleUsers: visibleUsers,
        omitted: visibleUsers.length != users.length,
        count: users.length
      }
    }
  },
  methods: {
    onClickMeetingRoom: function() {
      if (!this.meetingRoom.scheduled()) return
      this.$router.push({ name: 'showMeetingReservations', params: {
        videoRoomMasterId: this.meetingRoom.id,
        id: this.meetingRoom.meta.latestRoomInfo.id,
        returnPath: this.$route.path.slice(1)
      }})
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.meeting-room-card {
  text-align: center;
  margin-right: 10px;
  width: 100%;
  height: 150px;
  overflow: hidden;

  @include mq(md) {
    width: 250px;
  }

  &.clickable:hover {
    background-color: $light-gray-color;
  }

  .room-name {
    font-weight: 600;
    display: flex;

    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }

  .room-end-at {
    color: $secondary-color;
    font-size: 11px;
    font-weight: 600;
  }

  .scheduled {
    font-size: 13px;
  }

  .in-duration {
    display: flex;
    flex-wrap: wrap;
    align-self: flex-start;
    width: 100%;
    padding: 15px 10px 15px 15px;

    .avatar-wrapper {
      margin: 0 5px 5px 0;
    }
  }

  .omitted {
    flex-grow: 1;
    padding: 5px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 11px;
  }
}
</style>
